import { ConfirmModal } from '@app/components'
import { Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { type FC } from 'react'

import { Modal, type ModalProps } from './Modal'

export interface UnsavedChangesModalProps extends ModalProps {
  isChanged?: boolean
}

export const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  isChanged,
  children,
  onClose,
  opened,
  ...props
}) => {
  const [isConfirming, confirmModalHandler] = useDisclosure(false)

  return (
    <>
      <Modal
        onClose={() => {
          if (isChanged) {
            confirmModalHandler.open()
          } else {
            onClose()
          }
        }}
        opened={opened && !isConfirming}
        zIndex={1001}
        {...props}
      >
        {children}
      </Modal>
      <ConfirmModal
        cancelLabel='Oops, Nevermind'
        closeOnConfirm
        confirmLabel="Yes, I'm Sure"
        opened={isConfirming}
        onClose={confirmModalHandler.close}
        onConfirm={onClose}
        title='Unsaved Changes'
        zIndex={1002}
      >
        <Text size='sm'>You have unsaved changes, are you sure you want to cancel?</Text>
      </ConfirmModal>
    </>
  )
}
